import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
  message: '',
  variant: '',
}

const snackbar = (state = initialState, action) => {
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, open: false }
    case types.snackbar.NOTIFY:
      return { ...state, open: true, message: action.message, variant: action.variant }
    case types.snackbar.CLOSE:
      return { ...state, open: false }
    default:
      return state
  }
}

export default snackbar



// WEBPACK FOOTER //
// ./src/reducers/Common/Snackbar/Snackbar.js